// removed by extract-text-webpack-plugin
module.exports = {"section":"_3rhxgX1a_GG0JD2SR_7GWF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectReport/ProjectReport.scss
// module id = 633
// module chunks = 1